import React, { useState } from "react";

import { Card, Typography, Pagination, Table, Avatar } from "antd";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";

import { useSelector } from "react-redux";
// import BulkCoursesAdd from "../../../../components/AdminComponents/Modals/BulkCoursesAdd";
import BulkUsersAdd from "../../../../components/AdminComponents/Modals/BulkUsersAdd";
import { UserOutlined } from "@ant-design/icons";
import { capitalizeWords } from "../../../../components/icons/ApplicationColor";

const { Title } = Typography;
const Employees = (props) => {
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `user/?organization_id=${userInfo.data.organization.id}&role_id=${id}&organization_user_archived=False`,
    loadAgain: loadAgain,
    includeStatus: false,
    useOldPagination: true,
    takeFromData: (res) => res?.data?.data?.User_data,
    takeCountFrom: (res) => res?.data?.data?.paginator?.count,
  });
  function formatTypeText(text) {
    if (!text) return "";
    // Replace underscores with spaces, lowercase everything, then capitalize each word
    return text
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const columns = [
    {
      title: "Employee ID",
      dataIndex: "user_id",
      key: "user_id",
      width: 140,
    },
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
      width: 200,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar
            src={record?.profile_pic || null}
            icon={!record?.profile_pic && <UserOutlined />}
            alt={record?.first_name}
            size="small"
          />
          <span>
            {record?.first_name} {record?.last_name}
          </span>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 250,
      ellipsis: true,
    },
    {
      title: capitalizeWords("Type"),
      dataIndex: "user_type",
      key: "user_type",
      width: 150, // set width to 150px
      render: (text) => formatTypeText(text),
    },
  ];
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Employee Summary
      </Title>
      <CommonTopDetails
        title={`Role Employees`}
        titleSuffix={`${itemsLength || 0} user(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={true}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => setIsBulkModalOpen((prev) => !prev),
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 500,
        }}
        bordered
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <BulkUsersAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        bundle_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
        from="work-role"
      />
    </Card>
  );
};

export default Employees;
